import _ from 'lodash';
import React from 'react';
import {
  DateField,
  TextField,
  Labeled,
  BooleanField,
  SelectField,
  ReferenceManyField,
  SingleFieldList,
  FunctionField,
  ReferenceArrayField,
} from 'react-admin';
import { adminLevelLabels } from '../../../helpers/mappings';
import '../styles.css';
import FullNameField from '../../General/FullNameField';

const AccountStatusBanner = ({ data, ids, loadedOnce }) => {
  if (!loadedOnce) {
    return null;
  }
  const record = data[ids[0]];
  return (
    record && record.isClosed ?
      <span className="closedAccountBanner">ACCOUNT CLOSED</span> :
      <span className="activeAccountBanner">ACCOUNT ACTIVE</span>
  );
};

export default ({ record }) => (
  <table style={{ width: '100%' }}>
    <tbody>
      <tr>
        <td style={{ width: '50%' }}>
          <Labeled label="Account" record={record}>
            <ReferenceManyField label="Accounts" basePath="/accounts" reference="accounts" target="userId" source="id" record={record}>
              <SingleFieldList linkType={false}>
                <TextField source="accountNumber" />
              </SingleFieldList>
            </ReferenceManyField>
          </Labeled>
        </td>
        <td>
          <Labeled label="Account Status" record={record}>
            <ReferenceManyField label="Accounts" basePath="/accounts" reference="accounts" target="userId" source="id" record={record}>
              <AccountStatusBanner />
            </ReferenceManyField>
          </Labeled>
        </td>
      </tr>
      <tr>
        <td style={{ width: '50%' }}>
          <Labeled label="User Status">
            {record.status ? <span className="normalField">{record.status.charAt(0).toUpperCase() + record.status.slice(1)}</span> : <span className="normalField">N/A</span>}
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Full Name">
            <span className="normalField">{`${record.firstName}${_.isEmpty(record.middleName) ? ' ' : ` ${record.middleName} `}${record.lastName}`}</span>
          </Labeled>
        </td>
        <td>
          <Labeled label="Email">
            <TextField source="email" record={record} />
          </Labeled>
        </td>
        <td />
      </tr>
      <tr>
        <td>
          <Labeled label="Daytime Telephone">
            {record.contact ? <TextField source="contact.dayTelephone" record={record} /> : <span>N/A</span>}
          </Labeled>
        </td>
        <td>
          <Labeled label="Evening Telephone">
            {record.contact ? <TextField source="contact.eveningTelephone" record={record} /> : <span>N/A</span>}
          </Labeled>
        </td>
        <td />
      </tr>
      <tr>
        <td>
          <Labeled label="Role">
            {record.role ? <SelectField source="role" record={record} choices={adminLevelLabels} /> : <span className="normalField">No Role</span>}
          </Labeled>
        </td>
        <td>
          <Labeled label="Approved At">
            {record.approvedAt ? <DateField source="approvedAt" record={record} /> : <span className="normalField">Not Approved</span>}
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Created At">
            <DateField source="createdAt" record={record} />
          </Labeled>
        </td>
        <td>
          <Labeled label="Updated At">
            <DateField source="updatedAt" record={record} />
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Sign Up Completed At">
            {record.signUpCompletedAt ? <DateField source="signUpCompletedAt" record={record} /> : <span className="normalField">Not Completed</span>}
          </Labeled>
        </td>
        <td>
          <Labeled label="Is Solicited">
            <BooleanField source="solicited" record={record} />
          </Labeled>
        </td>
      </tr>
      <tr>
        <td />
        <FunctionField
          record={record}
          render={r => r.solicited && (
          <td>
            <Labeled label="Representatives Soliciting Advice">
              <ReferenceArrayField
                record={record}
                source="representatives"
                reference="userRepresentatives"
                label="Representatives Soliciting Advice"
                basePath="users"
                style={{ width: '100%' }}
              >
                <SingleFieldList>
                  <FullNameField />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </td>
        )}
        />
      </tr>
    </tbody>
  </table>
);



// WEBPACK FOOTER //
// ./src/components/User/children/BasicInformation_Show.jsx